module.exports = __webpack_public_path__ + "img/empty.8ad2a168.png";